// extracted by mini-css-extract-plugin
module.exports = {"loading-text":"loading-text__cbWPw","blink":"blink__4YSSA"};